import { message } from 'antd';
import ExportUtil from '../../common/ExportUtil';
import Fetch from '../../common/Fetch';
import API_URL from '../../common/url';

export default (params, url, type, pagination = {}) => {
    Fetch.post(API_URL.common.startAsynchronousExport, { type })
        .then(res => {
            const { success, asynchronousExportId } = res;
            message.success(success);
            ExportUtil.export({ ...params, asynchronousExportId }, pagination, url);
        })
        .catch(error => {
            console.error(error);
        });
};



// WEBPACK FOOTER //
// ./src/components/common/addToDownloadSite.js